@if ({ language: language$ | async }; as vm) {
  <div class="flex ninety-dialog-header">
    <h2 mat-dialog-title class="flex1">{{ vm.language?.issue?.item }} Settings</h2>
    <ninety-button flat mat-dialog-close aria-label="Close settings dialog">
      <terra-icon icon="x" size="20" />
    </ninety-button>
  </div>
  <form [formGroup]="form" cdkFocusRegionStart class="ninety-dialog-form">
    <div class="field-wrp">
      <terra-checkbox data-cy="issues-list-settings-dialog__show-priority-button" formControlName="issueRating">
        Show prioritization
        <terra-description>
          Display an additional field next to your {{ vm.language?.issue?.items }} that allows you to prioritize them
          from 1 to 5.
        </terra-description>
      </terra-checkbox>
    </div>
    <div class="field-wrp">
      <terra-checkbox data-cy="issues-list-settings-dialog__allow-voting-button" formControlName="issueVoting">
        Voting
        <terra-description>
          Allow {{ vm.language?.meeting?.item }} attendees to vote on {{ vm.language?.issue?.items }} for prioritization
          during a {{ vm.language?.meeting?.item }}.
        </terra-description>
      </terra-checkbox>
    </div>
    @if (form.contains('votesPerUser') && this.form.controls.issueVoting.value) {
      <div class="field-wrp compact inside num-votes">
        <mat-label>Votes per teammate *</mat-label>
        <terra-form-field class="outline-field short">
          <terra-number-input aria-label="Votes per teammate" formControlName="votesPerUser" />
        </terra-form-field>
        <mat-hint>The number of votes each teammate can cast during {{ vm.language?.issue?.item }} voting.</mat-hint>
      </div>
    }
    @if (form.contains('issuesSolveRate')) {
      <div class="field-wrp" formGroupName="issuesSolveRate">
        <terra-checkbox data-cy="issues-list-settings-dialog__set-solve-rate-button" formControlName="enabled">
          Set desired solve rate
          <terra-description>
            Help your team stay on track by setting a desired {{ vm.language?.issue?.item }} solve rate.
          </terra-description>
        </terra-checkbox>
        @if (form.controls.issuesSolveRate.controls.enabled.value) {
          <div class="field-wrp compact inside">
            <terra-form-field class="outline-field short percentage">
              <terra-number-input
                data-cy="issues-list-settings-dialog__desired-solve-rate-input"
                formControlName="value">
                <terra-input-suffix>
                  <terra-input-unit unit="%" />
                </terra-input-suffix>
              </terra-number-input>
            </terra-form-field>
          </div>
        }
      </div>
    }
  </form>
  <mat-dialog-actions>
    <ninety-button mat-dialog-close secondary stroked>Cancel</ninety-button>
    <ninety-button
      filled
      primary
      color="accent"
      [disabled]="form.invalid || !form.dirty"
      data-cy="issues-list-settings-dialog__save-button"
      id="save-issue-settings-btn"
      (click)="save()">
      Save
    </ninety-button>
  </mat-dialog-actions>
}
